/**
 * Shared status vocabulary for services and products.
 * Colours reference CSS custom properties from the existing design system.
 */

export const STATUS = {
  AVAILABLE: "Available",
  CUSTOMISABLE: "Customisable",
  QUOTE_ONLY: "Quote Only",
  COMING_SOON: "Coming Soon",
  ENGINEERING_VALIDATION: "Engineering Validation",
  RESEARCH: "Research",
  PROTOTYPE: "Prototype",
  UNDER_DEVELOPMENT: "Under Development",
  ACTIVE: "Active",
};

export const STATUS_META = {
  [STATUS.AVAILABLE]: { color: "var(--teal)", label: STATUS.AVAILABLE },
  [STATUS.CUSTOMISABLE]: { color: "var(--teal)", label: STATUS.CUSTOMISABLE },
  [STATUS.QUOTE_ONLY]: { color: "var(--gold)", label: STATUS.QUOTE_ONLY },
  [STATUS.COMING_SOON]: { color: "var(--gold)", label: STATUS.COMING_SOON },
  [STATUS.ENGINEERING_VALIDATION]: {
    color: "var(--gold)",
    label: STATUS.ENGINEERING_VALIDATION,
  },
  [STATUS.RESEARCH]: { color: "var(--purple)", label: STATUS.RESEARCH },
  [STATUS.PROTOTYPE]: { color: "var(--purple)", label: STATUS.PROTOTYPE },
  [STATUS.UNDER_DEVELOPMENT]: {
    color: "var(--gold)",
    label: STATUS.UNDER_DEVELOPMENT,
  },
  [STATUS.ACTIVE]: { color: "var(--teal)", label: STATUS.ACTIVE },
};

export function getStatusMeta(status) {
  return (
    STATUS_META[status] || {
      color: "var(--steel)",
      label: status || "Unknown",
    }
  );
}
